class DuplicateTestItemError extends Error {
    constructor(id) {
        super(`Attempted to insert a duplicate test item ID ${id}`);
    }
}
class InvalidTestItemError extends Error {
    constructor(id) {
        super(`TestItem with ID "${id}" is invalid. Make sure to create it from the createTestItem method.`);
    }
}
class MixedTestItemController extends Error {
    constructor(id, ctrlA, ctrlB) {
        super(`TestItem with ID "${id}" is from controller "${ctrlA}" and cannot be added as a child of an item from controller "${ctrlB}".`);
    }
}
const createTestItemChildren = (api, getApi, checkCtor) => {
    let mapped = ( new Map());
    return {
        get size() {
            return mapped.size;
        },
        forEach(callback, thisArg) {
            for (const item of ( mapped.values())) {
                callback.call(thisArg, item, this);
            }
        },
        [Symbol.iterator]() {
            return mapped.entries();
        },
        replace(items) {
            const newMapped = ( new Map());
            const toDelete = ( new Set(( mapped.keys())));
            const bulk = { op: 5 , ops: [] };
            for (const item of items) {
                if (!(item instanceof checkCtor)) {
                    throw new InvalidTestItemError(item.id);
                }
                const itemController = getApi(item).controllerId;
                if (itemController !== api.controllerId) {
                    throw new MixedTestItemController(item.id, itemController, api.controllerId);
                }
                if (( newMapped.has(item.id))) {
                    throw new DuplicateTestItemError(item.id);
                }
                newMapped.set(item.id, item);
                toDelete.delete(item.id);
                bulk.ops.push({ op: 0 , item });
            }
            for (const id of ( toDelete.keys())) {
                bulk.ops.push({ op: 3 , id });
            }
            api.listener?.(bulk);
            mapped = newMapped;
        },
        add(item) {
            if (!(item instanceof checkCtor)) {
                throw new InvalidTestItemError(item.id);
            }
            mapped.set(item.id, item);
            api.listener?.({ op: 0 , item });
        },
        delete(id) {
            if (mapped.delete(id)) {
                api.listener?.({ op: 3 , id });
            }
        },
        get(itemId) {
            return mapped.get(itemId);
        },
        toJSON() {
            return Array.from(( mapped.values()));
        },
    };
};
export { DuplicateTestItemError, InvalidTestItemError, MixedTestItemController, createTestItemChildren };
